/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MisclassificationThresholdAlertResource
 */
export interface MisclassificationThresholdAlertResource {
    /**
     * 
     * @type {string}
     * @memberof MisclassificationThresholdAlertResource
     */
    thresholdId: string;
    /**
     * 
     * @type {string}
     * @memberof MisclassificationThresholdAlertResource
     */
    thresholdName: string;
    /**
     * 
     * @type {string}
     * @memberof MisclassificationThresholdAlertResource
     */
    status: MisclassificationThresholdAlertResourceStatusEnum;
    /**
     * Difference between worked days and the threshold limit. Negative values represent days remaining before the limit (OK/WARNING). Zero or positive values represent days worked in excess of the limit (ALERT).
     * @type {number}
     * @memberof MisclassificationThresholdAlertResource
     */
    workedDaysRelativeToLimit: number;
}


/**
 * @export
 */
export const MisclassificationThresholdAlertResourceStatusEnum = {
    Ok: 'OK',
    Warning: 'WARNING',
    Alert: 'ALERT'
} as const;
export type MisclassificationThresholdAlertResourceStatusEnum = typeof MisclassificationThresholdAlertResourceStatusEnum[keyof typeof MisclassificationThresholdAlertResourceStatusEnum];


/**
 * Check if a given object implements the MisclassificationThresholdAlertResource interface.
 */
export function instanceOfMisclassificationThresholdAlertResource(value: object): value is MisclassificationThresholdAlertResource {
    if (!('thresholdId' in value) || value['thresholdId'] === undefined) return false;
    if (!('thresholdName' in value) || value['thresholdName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('workedDaysRelativeToLimit' in value) || value['workedDaysRelativeToLimit'] === undefined) return false;
    return true;
}

export function MisclassificationThresholdAlertResourceFromJSON(json: any): MisclassificationThresholdAlertResource {
    return MisclassificationThresholdAlertResourceFromJSONTyped(json, false);
}

export function MisclassificationThresholdAlertResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MisclassificationThresholdAlertResource {
    if (json == null) {
        return json;
    }
    return {
        
        'thresholdId': json['thresholdId'],
        'thresholdName': json['thresholdName'],
        'status': json['status'],
        'workedDaysRelativeToLimit': json['workedDaysRelativeToLimit'],
    };
}

export function MisclassificationThresholdAlertResourceToJSON(value?: MisclassificationThresholdAlertResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'thresholdId': value['thresholdId'],
        'thresholdName': value['thresholdName'],
        'status': value['status'],
        'workedDaysRelativeToLimit': value['workedDaysRelativeToLimit'],
    };
}

